import * as Yup from "yup";

export const BookingAppointmentSchema = Yup.object().shape({
  appointmentTypeId: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.number(),
    })
    .nullable(),
  member: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number(),
        preBooking: Yup.boolean(),
        package: Yup.number().when("preBooking", {
          is: true, // When preBooking is true
          then: Yup.number().nullable(), // Make package optional
          otherwise: Yup.number().required(
            "Please assign packages to all chosen members"
          ), // Require package
        }),
      })
    )
    .min(1, "Please Choose at least one member"),
  trainer: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.number(),
    })
    .nullable(),
  date: Yup.date().required("Date is required"),
  timeSlot: Yup.string().required("Time is required"),
  classId: Yup.number(),
});

export const FormatObjects = (
  data,
  name,
  count = false,
  idName,
  propName = false
) => {
  if (data && data.length > 0) {
    let arr;
    if (!propName) {
      arr = data.map((item) => {
        if (!count) {
          if (!idName) return { label: item[`${name}`], value: item.id };
          return { label: item[`${name}`], value: item[`${idName}`] };
        } else {
          if (!idName) {
            return {
              label: item[`${name}`],
              value: item.id,
              count: item.count || 0,
            };
          } else {
            return {
              label: item[`${name}`],
              value: item[`${idName}`],
              count: item.count || 0,
            };
          }
        }
      });
    } else {
      arr = data.map((item) => {
        if (!count) {
          if (!idName)
            return {
              label: item[`${propName}`][`${name}`],
              value: item[`${propName}`].id,
            };
          return {
            label: item[`${propName}`][`${name}`],
            value: item[`${propName}`][`${idName}`],
          };
        } else {
          if (!idName)
            return {
              label: item[`${propName}`][`${name}`],
              value: item[`${propName}`].id,
              count: item.count || 0,
            };
          return {
            label: item[`${propName}`][`${name}`],
            value: item[`${propName}`][`${idName}`],
            count: item.count || 0,
          };
        }
      });
    }
    return arr;
  } else return [];
};
